export const deleteSession = () => {
    localStorage.clear();
};
